import { render, staticRenderFns } from "./profile-view-personal.vue?vue&type=template&id=15589bbf&scoped=true&"
import script from "./profile-view-personal.vue?vue&type=script&lang=js&"
export * from "./profile-view-personal.vue?vue&type=script&lang=js&"
import style0 from "./profile-view-personal.vue?vue&type=style&index=0&id=15589bbf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15589bbf",
  null
  
)

export default component.exports